import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	empty: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedFetch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createNewItem: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	empty: {
		id: 'searchable-select.empty',
		defaultMessage: 'No matches found',
		description: 'Message when no options are found in a select',
	},
	failedFetch: {
		id: 'searchable-select.failed-fetch',
		defaultMessage: 'Search failed. Please try again.',
		description: 'Message when fetching suggestions fails',
	},
	placeholder: {
		id: 'searchable-select.placeholder',
		defaultMessage: 'Select an option',
		description: 'Placeholder text for select component',
	},
	loading: {
		id: 'searchable-select.loading',
		defaultMessage: 'Searching...',
		description: 'Message showed when options are being loaded from the server.',
	},
	createNewItem: {
		id: 'searchable-select.create-new-item',
		defaultMessage: 'Create',
		description: 'Message to show when user is asked to create a new item',
	},
});
export default messages;
